<template>
    <div>
		<el-alert type="warning" :closable="false">
			<div slot="title">
				<router-link to="/operation/advertis/listcalendar" class="color-danger">切换到月历视图<i class="el-icon-right"></i></router-link>
			</div>
		</el-alert>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="广告ID" :value="1"></el-option>
                            <el-option label="广告名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4">
                    <el-select v-model="params.showStatus" placeholder="请选择" size="small">
                        <el-option label="仅看展示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="2"></el-option>
                        <el-option label="不限制状态" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限制类型" :value="-1"></el-option>
                        <el-option label="仅看演出详情页的" :value="1"></el-option>
                        <el-option label="仅看众筹详情页的" :value="2"></el-option>
                        <el-option label="仅看周边详情页的" :value="3"></el-option>
                        <el-option label="仅看APP首页Banner下方的" :value="4"></el-option>
                        <el-option label="仅看APP我的页面的" :value="5"></el-option>
                        <el-option label="仅看订单详情页的" :value="6"></el-option>
                        <el-option label="仅看弹窗广告的" :value="7"></el-option>
                        <el-option label="仅看首页下拉广告" :value="9"></el-option>
						<el-option label="仅看搜索页广告" :value="10"></el-option>
						<el-option label="仅看一起看现场广告位" :value="11"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/advertising/save')"
                type="primary"
                icon="el-icon-plus"
                @click="$router.push({path: `/operation/advertis/add`})"
                size="small"
                >创建广告</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <p v-if="scope.row.showStatus === 1">展示</p>
                        <p v-else-if="scope.row.showStatus === 2">隐藏</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="广告名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column label="广告位"  width="180">
                    <template slot-scope="scope">
                        <p v-if="scope.row.type === 4">APP首页Banner下方</p>
                        <p v-else-if="scope.row.type === 5">APP我的页面</p>
                        <p v-else-if="scope.row.type === 1">演出详情页</p>
                        <p v-else-if="scope.row.type === 2">众筹详情页</p>
                        <p v-else-if="scope.row.type === 3">周边详情页</p>
                        <p v-else-if="scope.row.type === 6">订单详情页</p>
                        <p v-else-if="scope.row.type === 7">弹窗广告</p>
                        <p v-else-if="scope.row.type === 9">首页下拉广告</p>
						<p v-else-if="scope.row.type === 10">搜索页广告</p>
						<p v-else-if="scope.row.type === 11">一起看现场广告位</p>
                    </template>
                </el-table-column>
				<el-table-column label="订单转化">
				    <template slot-scope="scope">
				       <p>下单人数：<span v-if="scope.row.orderUserCount">{{ scope.row.orderUserCount }}</span></p>
				       <p>转化率：<span v-if="scope.row.orderCr">{{ scope.row.orderCr }}%</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="订单">
				    <template slot-scope="scope">
				       <p>订单数：<span v-if="scope.row.orderCount">{{ scope.row.orderCount }}</span></p>
				       <p>销售额：<span v-if="scope.row.saleAmountView">{{ scope.row.saleAmountView }}</span></p>
				    </template>
				</el-table-column>
                <el-table-column width="180" label="展示时间段1">
                    <template slot-scope="scope">
                        <p>起：{{ scope.row.showStartDate }}</p>
                        <p>止：{{ scope.row.showEndDate }}</p>
                    </template>
                </el-table-column>
				<el-table-column width="180" label="展示时间段2">
				    <template slot-scope="scope">
				        <p v-if="scope.row.firstShowStartDate">起：{{ scope.row.firstShowStartDate }}</p>
				        <p v-if="scope.row.firstShowEndDate">止：{{ scope.row.firstShowEndDate }}</p>
				    </template>
				</el-table-column>
				<el-table-column width="180" label="展示时间段3">
				    <template slot-scope="scope">
				        <p v-if="scope.row.secondShowStartDate">起：{{ scope.row.secondShowStartDate }}</p>
				        <p v-if="scope.row.secondShowEndDate">止：{{ scope.row.secondShowEndDate }}</p>
				    </template>
				</el-table-column>
                <el-table-column fixed="right" width="120" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/advertising/info')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="$router.push({path: `/operation/advertis/detail/${scope.row.id}`})"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultQuery = {
    pageNo: 1,
    showStatus: 1,
    searchType: 1,
    searchValue: '',
    type: -1,
};
export default {
    data() {
        return {
            visible: false,
            params: {
                ...defaultQuery,
                pageSize: this.$pageSizes[0],
            },
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
        showTerminal (str) {
            const name = ['WEB', 'WAPCN', 'APP', 'WAPEN'];
            return str.split(',').map(item => name[item - 1]).toString().replace(/,/g, "/");
        },
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/advertising/list",
                method: "POST",
                data: this.params,
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultQuery,
                pageSize: this.params.pageSize,
            };
            this.search();
        }
    },
};
</script>
